interface Props {
  onStart: (storylineId?: string) => void;
  onLeaderboard: () => void;
  aiVsHuman: boolean;
  onToggleAiVsHuman: () => void;
  loading: boolean;
  playerName: string;
  playerEmail: string;
  onPlayerNameChange: (v: string) => void;
  onPlayerEmailChange: (v: string) => void;
}

const STORYLINES = [
  {
    id: 'ghostpay',
    name: 'GhostPay',
    tagline: 'Card-not-present fraud & international laundering',
    icon: '👻',
  },
  {
    id: 'identityshift',
    name: 'IdentityShift',
    tagline: 'Synthetic identity & bust-out fraud',
    icon: '🎭',
  },
  {
    id: 'shadowmerchant',
    name: 'ShadowMerchant',
    tagline: 'Ghost merchant collusion & refund fraud',
    icon: '🕵️',
  },
];

export function StartPage({ onStart, onLeaderboard, aiVsHuman, onToggleAiVsHuman, loading, playerName, playerEmail, onPlayerNameChange, onPlayerEmailChange }: Props) {
  const ready = playerName.trim().length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(playerEmail.trim());
  const disabled = loading || !ready;

  return (
    <div className="start-page">
      <div className="start-hero">
        <div className="hero-badge">AWS Summit · Financial Services</div>
        <h1 className="hero-title">Fraud or Not?</h1>
        <p className="hero-sub">
          Think like a fraud analyst. Review 10 transactions and decide: legitimate, suspicious, or fraudulent.
          Then see how your instincts compare to an AI model powered by Amazon Bedrock.
        </p>
      </div>

      <div className="player-form">
        <input
          type="text"
          className="player-input"
          placeholder="Your name"
          maxLength={32}
          value={playerName}
          onChange={(e) => onPlayerNameChange(e.target.value)}
        />
        <input
          type="email"
          className="player-input"
          placeholder="Your email"
          value={playerEmail}
          onChange={(e) => onPlayerEmailChange(e.target.value)}
        />
      </div>

      <div className="toggle-row">
        <span className="toggle-label">AI vs Human Mode</span>
        <button
          className={`toggle-btn ${aiVsHuman ? 'active' : ''}`}
          onClick={onToggleAiVsHuman}
          aria-pressed={aiVsHuman}
        >
          <span className="toggle-thumb" />
        </button>
        <span className="toggle-hint">
          {aiVsHuman ? 'AI verdict revealed after each card' : 'Compare at the end'}
        </span>
      </div>

      <div className="storyline-grid">
        {STORYLINES.map((s) => (
          <button
            key={s.id}
            className="storyline-card"
            onClick={() => onStart(s.id)}
            disabled={disabled}
          >
            <span className="storyline-icon">{s.icon}</span>
            <span className="storyline-name">{s.name}</span>
            <span className="storyline-tagline">{s.tagline}</span>
          </button>
        ))}
      </div>

      <button
        className="btn-random"
        onClick={() => onStart()}
        disabled={disabled}
      >
        {loading ? 'Loading case...' : 'Random Case'}
      </button>

      <button className="btn-leaderboard-link" onClick={onLeaderboard}>
        View Today's Leaderboard →
      </button>
    </div>
  );
}
